import { Result, type ResultProps, Card } from "antd";
import { AxiosError } from "axios";

type ResultStatusType =
    | 403
    | 404
    | 500
    | "403"
    | "404"
    | "500"
    | "error"
    | "info"
    | "warning"
    | "success";

export interface CustomResultProps extends ResultProps {
    type?: "success" | "error" | "info" | "warning";
    axiosError?: AxiosError;
    withCard?: boolean;
}

export const isExceptionStatusType = (
    v: unknown,
): v is 403 | 404 | 500 | "403" | "404" | "500" | "error" =>
    v === "error" ||
    v === 403 ||
    v === 404 ||
    v === 500 ||
    v === "403" ||
    v === "404" ||
    v === "500";

export const toExceptionStatus = (v: unknown): ResultStatusType =>
    isExceptionStatusType(v) ? v : "error";

export default function CustomResult({
    type = "info",
    status,
    title,
    subTitle,
    axiosError,
    withCard,
    extra,
}: CustomResultProps) {
    if (type === "error") {
        status = toExceptionStatus(axiosError?.status ?? "error");
        // console.log("CustomResult error status: ", status);
        // console.log("axiosError: ", axiosError);

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const error = axiosError?.response?.data ?? (null as any);
        // console.log("CustomResult error: ", error);
        if (error == null) {
            status = 500;
            subTitle = "Ошибка Сервера";
        } else if (error.detail) subTitle = error.detail;
    }

    const result = <Result status={status} title={title} subTitle={subTitle} extra={extra} />;

    if (withCard) return <Card>{result}</Card>;

    return result;
}
